// extracted by mini-css-extract-plugin
export default {"speedometer":"style_speedometer__M5wUe","progress":"style_progress__z5f5Z","dark":"style_dark__fC+3u"};